import React, { Component } from "react";
import {
  Card,
  CardBody,
  Col,
  Row,
  Button,
  Container,
  Badge,
  Input,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  CustomInput,
} from "reactstrap";
import {
  getVehicleTypesAdmin,
  createVehicleType,
  updateVehicleType,
  deleteVehicleType,
  getTransportSettings,
} from "../../Endpoint/Admin/index";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";

class VehicleTypes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vehicleTypes: [],
      isLoaded: false,
      showModal: false,
      showDeleteModal: false,
      editingVehicle: null,
      deletingVehicle: null,
      nightRateMultiplier: 1.5, // Default, will be loaded from settings
      formData: {
        code: "",
        name: "",
        description: "",
        maxPassengers: 4,
        maxLuggage: 3,
        fixedAmount: 50,
        perKmRate: 2.0,
        dayPrice: 0,
        nightPrice: 0,
        currency: "USD",
        icon: "ri-car-line",
        displayOrder: 1,
        isActive: true,
        discount: {
          isEnabled: false,
          type: "percentage",
          value: 0,
          displayLabel: "",
        },
        availableFor: {
          taxi: false,
          airportTransfer: false,
          intercity: false,
          outstation: false,
          dayRental: false,
        },
        showPrice: true, // If false, shows "Quote on Request" in mobile app
      },
      breadcrumbItems: [
        { title: "Dashboard", link: "/dashboard" },
        { title: "Transport", link: "/transport/requests" },
        { title: "Vehicle Types", link: "#" },
      ],
    };
  }

  componentDidMount() {
    this.loadVehicleTypes();
    this.loadSettings();
  }

  loadSettings = () => {
    getTransportSettings()
      .then((result) => {
        if (result && result.status === 200 && result.data) {
          this.setState({
            nightRateMultiplier: result.data.defaultNightRateMultiplier || 1.5,
          });
        }
      })
      .catch(() => console.log("Could not load transport settings"));
  };

  loadVehicleTypes = () => {
    getVehicleTypesAdmin()
      .then((result) => {
        if (result && result.status === 200) {
          this.setState({ vehicleTypes: result.data, isLoaded: true });
        } else {
          toast.error(result?.message || "Failed to load vehicle types");
        }
      })
      .catch(() => toast.error("Error loading vehicle types"));
  };

  getDefaultFormData = () => ({
    code: "",
    name: "",
    description: "",
    maxPassengers: 4,
    maxLuggage: 3,
    fixedAmount: 50,
    perKmRate: 2.0,
    dayPrice: 0,
    nightPrice: 0,
    currency: "USD",
    icon: "ri-car-line",
    displayOrder: this.state.vehicleTypes.length + 1,
    isActive: true,
    discount: {
      isEnabled: false,
      type: "percentage",
      value: 0,
      displayLabel: "",
    },
    availableFor: {
      taxi: false,
      airportTransfer: false,
      intercity: false,
      outstation: false,
      dayRental: false,
    },
    showPrice: true,
  });

  handleAdd = () => {
    this.setState({
      editingVehicle: null,
      formData: this.getDefaultFormData(),
      showModal: true,
    });
  };

  handleEdit = (vehicle) => {
    this.setState({
      editingVehicle: vehicle,
      formData: {
        code: vehicle.code,
        name: vehicle.name,
        description: vehicle.description || "",
        maxPassengers: vehicle.maxPassengers,
        maxLuggage: vehicle.maxLuggage,
        fixedAmount: vehicle.fixedAmount,
        perKmRate: vehicle.perKmRate,
        dayPrice: vehicle.dayPrice || 0,
        nightPrice: vehicle.nightPrice || 0,
        currency: vehicle.currency,
        icon: vehicle.icon || "ri-car-line",
        displayOrder: vehicle.displayOrder,
        isActive: vehicle.isActive,
        discount: vehicle.discount || {
          isEnabled: false,
          type: "percentage",
          value: 0,
          displayLabel: "",
        },
        availableFor: {
          taxi: vehicle.availableFor?.taxi || false,
          airportTransfer: vehicle.availableFor?.airportTransfer || false,
          intercity: vehicle.availableFor?.intercity || false,
          outstation: vehicle.availableFor?.outstation || false,
          dayRental: vehicle.availableFor?.dayRental || false,
        },
        showPrice: vehicle.showPrice !== false, // Default to true if not set
      },
      showModal: true,
    });
  };

  handleDelete = (vehicle) => {
    this.setState({
      deletingVehicle: vehicle,
      showDeleteModal: true,
    });
  };

  confirmDelete = () => {
    const { deletingVehicle } = this.state;
    deleteVehicleType(deletingVehicle._id)
      .then((response) => {
        if (response && response.status === 200) {
          toast.success("Vehicle type deleted successfully");
          this.setState({ showDeleteModal: false, deletingVehicle: null });
          this.loadVehicleTypes();
        } else {
          toast.error(response?.message || "Failed to delete vehicle type");
        }
      })
      .catch(() => toast.error("Error deleting vehicle type"));
  };

  handleSave = () => {
    const { editingVehicle, formData } = this.state;

    if (!formData.code || !formData.name) {
      toast.error("Code and Name are required");
      return;
    }

    const saveData = { ...formData };

    if (editingVehicle) {
      updateVehicleType(editingVehicle._id, saveData)
        .then((response) => {
          if (response && response.status === 200) {
            toast.success("Vehicle type updated successfully");
            this.setState({ showModal: false, editingVehicle: null });
            this.loadVehicleTypes();
          } else {
            toast.error(response?.message || "Failed to update vehicle type");
          }
        })
        .catch(() => toast.error("Error updating vehicle type"));
    } else {
      createVehicleType(saveData)
        .then((response) => {
          if (response && response.status === 200) {
            toast.success("Vehicle type created successfully");
            this.setState({ showModal: false });
            this.loadVehicleTypes();
          } else {
            toast.error(response?.message || "Failed to create vehicle type");
          }
        })
        .catch(() => toast.error("Error creating vehicle type"));
    }
  };

  updateFormData = (field, value) => {
    this.setState((prevState) => {
      const newFormData = {
        ...prevState.formData,
        [field]: value,
      };

      return { formData: newFormData };
    });
  };

  updateDiscount = (field, value) => {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        discount: {
          ...prevState.formData.discount,
          [field]: value,
        },
      },
    }));
  };

  updateAvailableFor = (field, value) => {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        availableFor: {
          ...prevState.formData.availableFor,
          [field]: value,
        },
      },
    }));
  };

  renderPriceWithDiscount = (vehicle) => {
    if (vehicle.discount?.isEnabled && vehicle.discount?.value > 0) {
      let discountedFixed = vehicle.fixedAmount;
      let discountedPerKm = vehicle.perKmRate;

      if (vehicle.discount.type === "percentage") {
        discountedFixed = vehicle.fixedAmount * (1 - vehicle.discount.value / 100);
        discountedPerKm = vehicle.perKmRate * (1 - vehicle.discount.value / 100);
      } else {
        discountedFixed = vehicle.fixedAmount - vehicle.discount.value;
        discountedPerKm = vehicle.perKmRate - (vehicle.discount.value / 10);
      }

      return (
        <div>
          <span className="text-muted text-decoration-line-through mr-2">
            ${vehicle.fixedAmount}
          </span>
          <span className="text-success font-weight-bold">
            ${discountedFixed.toFixed(0)}
          </span>
          <br />
          <small className="text-muted text-decoration-line-through mr-2">
            ${vehicle.perKmRate}/km
          </small>
          <small className="text-success font-weight-bold">
            ${discountedPerKm.toFixed(2)}/km
          </small>
          <br />
          <Badge color="success" className="mt-1">
            {vehicle.discount.displayLabel || `${vehicle.discount.value}${vehicle.discount.type === 'percentage' ? '%' : '$'} OFF`}
          </Badge>
        </div>
      );
    }

    return (
      <div>
        <span className="font-weight-bold">${vehicle.fixedAmount}</span>
        <br />
        <small>${vehicle.perKmRate}/km</small>
      </div>
    );
  };

  render() {
    const { vehicleTypes, showModal, showDeleteModal, editingVehicle, deletingVehicle, formData } = this.state;

    const iconOptions = [
      { value: "ri-car-line", label: "Car" },
      { value: "ri-car-fill", label: "Car (Filled)" },
      { value: "ri-taxi-line", label: "Taxi" },
      { value: "ri-taxi-fill", label: "Taxi (Filled)" },
      { value: "ri-bus-line", label: "Bus/Van" },
      { value: "ri-bus-fill", label: "Bus (Filled)" },
      { value: "ri-truck-line", label: "Truck/SUV" },
      { value: "ri-roadster-line", label: "Roadster/Sports" },
      { value: "ri-vip-crown-line", label: "VIP/Luxury" },
      { value: "ri-vip-crown-fill", label: "VIP (Filled)" },
      { value: "ri-e-bike-line", label: "Bike/Motorcycle" },
      { value: "ri-motorbike-line", label: "Motorbike" },
      { value: "ri-riding-line", label: "Auto Rickshaw" },
      { value: "ri-caravan-line", label: "Van/Caravan" },
      { value: "ri-train-line", label: "Train/Metro" },
      { value: "ri-flight-takeoff-line", label: "Airport" },
      { value: "ri-ship-line", label: "Boat/Ship" },
    ];

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="Vehicle Types" breadcrumbItems={this.state.breadcrumbItems} />

            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h4 className="card-title mb-0">
                    <i className="ri-car-line mr-2"></i>
                    Vehicle Type Management
                  </h4>
                  <div>
                    <Link to="/transport/requests" className="mr-2">
                      <Button color="secondary" outline size="sm">
                        <i className="ri-arrow-left-line mr-1"></i> Back
                      </Button>
                    </Link>
                    <Button color="primary" size="sm" onClick={this.handleAdd}>
                      <i className="ri-add-line mr-1"></i> Add Vehicle Type
                    </Button>
                  </div>
                </div>
                <div className="table-responsive">
                  <Table className="table-centered mb-0">
                    <thead className="thead-light">
                      <tr>
                        <th>Vehicle</th>
                        <th>Capacity</th>
                        <th>Pricing</th>
                        <th>Available For</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {vehicleTypes.map((vehicle) => (
                        <tr key={vehicle._id}>
                          <td>
                            <div className="d-flex align-items-center">
                              <div
                                className="avatar-sm rounded-circle bg-soft-primary mr-3"
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <i className={`${vehicle.icon || 'ri-car-line'} font-size-20 text-primary`}></i>
                              </div>
                              <div>
                                <h6 className="mb-0">{vehicle.name}</h6>
                                <small className="text-muted">{vehicle.code}</small>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div>
                              <i className="ri-user-line mr-1"></i> {vehicle.maxPassengers} guests
                              <br />
                              <i className="ri-luggage-cart-line mr-1"></i> {vehicle.maxLuggage} bags
                            </div>
                          </td>
                          <td>{this.renderPriceWithDiscount(vehicle)}</td>
                          <td>
                            <div>
                              {vehicle.availableFor?.taxi && <Badge color="info" className="mr-1 mb-1">Taxi</Badge>}
                              {vehicle.availableFor?.airportTransfer && <Badge color="primary" className="mr-1 mb-1">Airport</Badge>}
                              {vehicle.availableFor?.intercity && <Badge color="success" className="mr-1 mb-1">Intercity</Badge>}
                              {vehicle.availableFor?.outstation && <Badge color="warning" className="mr-1 mb-1">Outstation</Badge>}
                              {vehicle.availableFor?.dayRental && <Badge color="secondary" className="mr-1 mb-1">Day Rental</Badge>}
                              {!vehicle.availableFor?.taxi && !vehicle.availableFor?.airportTransfer &&
                               !vehicle.availableFor?.intercity && !vehicle.availableFor?.outstation &&
                               !vehicle.availableFor?.dayRental && (
                                <Badge color="danger" className="mr-1 mb-1">None Selected</Badge>
                              )}
                            </div>
                          </td>
                          <td>
                            <Badge color={vehicle.isActive ? "success" : "secondary"}>
                              {vehicle.isActive ? "Active" : "Inactive"}
                            </Badge>
                          </td>
                          <td>
                            <Button color="light" size="sm" className="mr-1" onClick={() => this.handleEdit(vehicle)}>
                              <i className="ri-edit-line"></i>
                            </Button>
                            <Button color="danger" size="sm" outline onClick={() => this.handleDelete(vehicle)}>
                              <i className="ri-delete-bin-line"></i>
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>

                {vehicleTypes.length === 0 && (
                  <div className="text-center py-5">
                    <i className="ri-car-line ri-3x text-muted mb-3"></i>
                    <h5>No Vehicle Types Found</h5>
                    <p className="text-muted">Run the seed script or add vehicle types manually.</p>
                    <code>node database/seedVehicleTypes.js</code>
                  </div>
                )}
              </CardBody>
            </Card>
          </Container>
        </div>

        {/* Add/Edit Modal */}
        <Modal isOpen={showModal} toggle={() => this.setState({ showModal: false })} size="lg">
          <ModalHeader toggle={() => this.setState({ showModal: false })}>
            {editingVehicle ? `Edit: ${editingVehicle.name}` : "Add Vehicle Type"}
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Code *</Label>
                  <Input
                    type="text"
                    value={formData.code}
                    onChange={(e) => this.updateFormData("code", e.target.value.toUpperCase())}
                    placeholder="e.g., SEDAN, SUV"
                    disabled={!!editingVehicle}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Name *</Label>
                  <Input
                    type="text"
                    value={formData.name}
                    onChange={(e) => this.updateFormData("name", e.target.value)}
                    placeholder="e.g., Sedan, SUV"
                  />
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup>
                  <Label>Description</Label>
                  <Input
                    type="textarea"
                    rows={2}
                    value={formData.description}
                    onChange={(e) => this.updateFormData("description", e.target.value)}
                    placeholder="Brief description of this vehicle type"
                  />
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label>Max Passengers</Label>
                  <Input
                    type="number"
                    value={formData.maxPassengers}
                    onChange={(e) => this.updateFormData("maxPassengers", parseInt(e.target.value) || 0)}
                    min="1"
                  />
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label>Max Luggage</Label>
                  <Input
                    type="number"
                    value={formData.maxLuggage}
                    onChange={(e) => this.updateFormData("maxLuggage", parseInt(e.target.value) || 0)}
                    min="0"
                  />
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label>Icon</Label>
                  <div className="d-flex align-items-center">
                    <div
                      className="mr-2 d-flex align-items-center justify-content-center bg-soft-primary rounded"
                      style={{ width: "40px", height: "38px" }}
                    >
                      <i className={`${formData.icon} text-primary`} style={{ fontSize: "20px" }}></i>
                    </div>
                    <Input
                      type="select"
                      value={formData.icon}
                      onChange={(e) => this.updateFormData("icon", e.target.value)}
                      style={{ flex: 1 }}
                    >
                      {iconOptions.map((opt) => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </Input>
                  </div>
                  <small className="text-muted">Icon displayed in mobile app</small>
                </FormGroup>
              </Col>

              <Col xs={12}>
                <hr />
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="mb-0">Pricing</h6>
                  <FormGroup check className="mb-0">
                    <Label check className="d-flex align-items-center">
                      <Input
                        type="checkbox"
                        checked={formData.showPrice}
                        onChange={(e) => this.updateFormData("showPrice", e.target.checked)}
                      />{" "}
                      <span className="ml-2">Show Price in App</span>
                    </Label>
                  </FormGroup>
                </div>
                {!formData.showPrice && (
                  <div className="alert alert-info py-2 mb-3">
                    <i className="ri-information-line mr-2"></i>
                    <small>Mobile app will show <strong>"Quote on Request"</strong> instead of prices</small>
                  </div>
                )}
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label>Fixed Amount (Taxi)</Label>
                  <Input
                    type="number"
                    value={formData.fixedAmount}
                    onChange={(e) => this.updateFormData("fixedAmount", parseFloat(e.target.value) || 0)}
                    min="0"
                    step="0.01"
                    disabled={!formData.showPrice}
                  />
                  <small className="text-muted">Used for local taxi rides</small>
                </FormGroup>
              </Col>
              </Row>
              <Row>
              <Col md={4}>
                <FormGroup>
                  <Label>Display Order</Label>
                  <Input
                    type="number"
                    value={formData.displayOrder}
                    onChange={(e) => this.updateFormData("displayOrder", parseInt(e.target.value) || 1)}
                    min="1"
                  />
                </FormGroup>
              </Col>

              <Col xs={12}>
                <hr />
                <h6>Discount Settings</h6>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label>Enable Discount</Label>
                  <div>
                    <CustomInput
                      type="switch"
                      id="discountEnabled"
                      checked={formData.discount.isEnabled}
                      onChange={(e) => this.updateDiscount("isEnabled", e.target.checked)}
                    />
                  </div>
                </FormGroup>
              </Col>
              {formData.discount.isEnabled && (
                <>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Discount Type</Label>
                      <Input
                        type="select"
                        value={formData.discount.type}
                        onChange={(e) => this.updateDiscount("type", e.target.value)}
                      >
                        <option value="percentage">Percentage (%)</option>
                        <option value="fixed">Fixed Amount ($)</option>
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Discount Value</Label>
                      <Input
                        type="number"
                        value={formData.discount.value}
                        onChange={(e) => this.updateDiscount("value", parseFloat(e.target.value) || 0)}
                        min="0"
                        step="0.01"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Display Label</Label>
                      <Input
                        type="text"
                        value={formData.discount.displayLabel}
                        onChange={(e) => this.updateDiscount("displayLabel", e.target.value)}
                        placeholder="e.g., 10% OFF"
                      />
                    </FormGroup>
                  </Col>
                </>
              )}

              <Col xs={12}>
                <hr />
                <h6>Available For</h6>
                <small className="text-muted d-block mb-3">
                  Select which services this vehicle type will be available for in the mobile app
                </small>
              </Col>
              <Col md={4} className="mb-3">
                <div className={`p-3 border rounded ${formData.availableFor.taxi ? 'border-info bg-soft-info' : ''}`}>
                  <FormGroup check className="mb-2">
                    <Label check>
                      <Input
                        type="checkbox"
                        checked={formData.availableFor.taxi}
                        onChange={(e) => this.updateAvailableFor("taxi", e.target.checked)}
                      />{" "}
                      <strong>Taxi</strong>
                    </Label>
                  </FormGroup>
                  <small className="text-muted d-block">
                    <i className="ri-map-pin-line mr-1"></i>
                    Short trips within city. Uses <strong>Fixed Amount</strong> pricing.
                  </small>
                </div>
              </Col>
              <Col md={4} className="mb-3">
                <div className={`p-3 border rounded ${formData.availableFor.airportTransfer ? 'border-primary bg-soft-primary' : ''}`}>
                  <FormGroup check className="mb-2">
                    <Label check>
                      <Input
                        type="checkbox"
                        checked={formData.availableFor.airportTransfer}
                        onChange={(e) => this.updateAvailableFor("airportTransfer", e.target.checked)}
                      />{" "}
                      <strong>Airport Transfer</strong>
                    </Label>
                  </FormGroup>
                  <small className="text-muted d-block">
                    <i className="ri-flight-takeoff-line mr-1"></i>
                    To/from airport. Uses <strong>Day/Night</strong> pricing.
                  </small>
                </div>
              </Col>
              <Col md={4} className="mb-3">
                <div className={`p-3 border rounded ${formData.availableFor.intercity ? 'border-success bg-soft-success' : ''}`}>
                  <FormGroup check className="mb-2">
                    <Label check>
                      <Input
                        type="checkbox"
                        checked={formData.availableFor.intercity}
                        onChange={(e) => this.updateAvailableFor("intercity", e.target.checked)}
                      />{" "}
                      <strong>Inter-city</strong>
                    </Label>
                  </FormGroup>
                  <small className="text-muted d-block">
                    <i className="ri-road-map-line mr-1"></i>
                    Long distance, same day return. Uses <strong>Per KM Rate</strong>.
                  </small>
                </div>
              </Col>
              <Col md={4} className="mb-3">
                <div className={`p-3 border rounded ${formData.availableFor.outstation ? 'border-warning bg-soft-warning' : ''}`}>
                  <FormGroup check className="mb-2">
                    <Label check>
                      <Input
                        type="checkbox"
                        checked={formData.availableFor.outstation}
                        onChange={(e) => this.updateAvailableFor("outstation", e.target.checked)}
                      />{" "}
                      <strong>Outstation</strong>
                    </Label>
                  </FormGroup>
                  <small className="text-muted d-block">
                    <i className="ri-compass-line mr-1"></i>
                    Multi-day trips out of town. Uses <strong>Per KM Rate</strong>.
                  </small>
                </div>
              </Col>
              <Col md={4} className="mb-3">
                <div className={`p-3 border rounded ${formData.availableFor.dayRental ? 'border-secondary bg-soft-secondary' : ''}`}>
                  <FormGroup check className="mb-2">
                    <Label check>
                      <Input
                        type="checkbox"
                        checked={formData.availableFor.dayRental}
                        onChange={(e) => this.updateAvailableFor("dayRental", e.target.checked)}
                      />{" "}
                      <strong>Day Rental</strong>
                    </Label>
                  </FormGroup>
                  <small className="text-muted d-block">
                    <i className="ri-calendar-line mr-1"></i>
                    Rent vehicle for full day. Uses <strong>Fixed Amount</strong>.
                  </small>
                </div>
              </Col>

              <Col xs={12} className="mt-3">
                <FormGroup check>
                  <Label check>
                    <Input
                      type="checkbox"
                      checked={formData.isActive}
                      onChange={(e) => this.updateFormData("isActive", e.target.checked)}
                    />{" "}
                    Vehicle type is active
                  </Label>
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => this.setState({ showModal: false })}>
              Cancel
            </Button>
            <Button color="primary" onClick={this.handleSave}>
              {editingVehicle ? "Update" : "Create"}
            </Button>
          </ModalFooter>
        </Modal>

        {/* Delete Confirmation Modal */}
        <Modal isOpen={showDeleteModal} toggle={() => this.setState({ showDeleteModal: false })}>
          <ModalHeader toggle={() => this.setState({ showDeleteModal: false })}>
            Confirm Delete
          </ModalHeader>
          <ModalBody>
            <p>Are you sure you want to delete <strong>{deletingVehicle?.name}</strong>?</p>
            <p className="text-danger">This action cannot be undone.</p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => this.setState({ showDeleteModal: false })}>
              Cancel
            </Button>
            <Button color="danger" onClick={this.confirmDelete}>
              Delete
            </Button>
          </ModalFooter>
        </Modal>

        <ToastContainer />
      </React.Fragment>
    );
  }
}

export default VehicleTypes;
